import Vue from "vue";
import Cookies from "js-cookie";
import axios from "../axios";
import jwt_decode from "jwt-decode";
import store from "../store/index";
import VueRouter from "vue-router";
import UnverifiedPhotos from "../pages/UnverifiedPhotos.vue";
import WaintingUsers from "../pages/WaintingUsers.vue";
import Users from "../pages/Users.vue";
import UserDetails from "../pages/UserDetails.vue";
import Mail from "../pages/Mail.vue";
import Login from "../pages/Login.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import Rooms from "../pages/chat/Rooms.vue";
import Messages from "../pages/chat/Messages.vue";
import SearchUser from "../pages/SearchUser";
import Settings from "../pages/settings/Settings.vue";
import CreateService from "../pages/settings/CreateService.vue";
import ServicesList from "../pages/settings/ServicesList.vue";
import PushNotifications from "../pages/settings/PushNotifications.vue";
import NotificationsList from "../pages/settings/NotificationsList.vue";
import Commission from "../pages/settings/Commission.vue";
import ServicesHistory from "../pages/ServicesHistory.vue";
import ServicesOrder from "../pages/settings/ServicesOrder.vue";
import DeleteRequests from "../pages/settings/DeleteRequests.vue";
import SendMessage from "../pages/settings/SendMessage.vue";
import SendEmail from "../pages/settings/SendEmail.vue";
import Parameters from "../pages/settings/Parameters.vue";
import Logs from "../pages/Logs.vue";
import PaymentsList from "../pages/PaymentsList.vue";
import UserServices from "../pages/UserServices.vue";
import EmployeeOrders from "../pages/EmployeeOrders.vue";
import SeniorOrders from "../pages/SeniorOrders.vue";
import ServicesCategories from "../pages/settings/ServicesCategories.vue";
import Payouts from "../pages/Payouts.vue";
import SeniorProfile from "../pages/SeniorProfile.vue";
import EmployeeProfile from "../pages/EmployeeProfile.vue";
import SeniorOrdersCrs from "../pages/SeniorOrdersCrs.vue";
import Subscriptions from "../pages/Subscriptions.vue";
import NoAccess from "../pages/NoAccess.vue";
import AddAdmin from "../pages/settings/AddAdmin.vue";
import UserCommisions from "../pages/UserCommisions.vue";
import Tasks from "../pages/Tasks.vue";
import Notes from "../pages/Notes.vue";
import Reports from "../pages/settings/Reports.vue";
import SmsList from "../pages/SmsList.vue";
import SmsListUser from "../pages/SmsListUser.vue";
import UsersWithServiceInArea from "../pages/settings/UsersWithServiceInArea";
import Promotions from "../pages/settings/Promotions";
import UserPromotions from "../pages/UserPromotions.vue";
import UsersWhoTriedToLogIn from "../pages/UsersWhoTriedToLogIn.vue";
import CreateSubCategory from "../pages/settings/CreateSubCategory.vue";
import LongDistanceServices from "../pages/settings/LongDistanceServices.vue";
import ModalsManagement from "../pages/settings/ModalsManagement";
import UserProcessPaymentView from "@/pages/UserProcess/UserProcessPaymentView";
import News from "@/pages/settings/News";
import AccountingNotesDescriptions from "@/pages/settings/AccountingNotesDescriptions";
import GenerateSQL from "@/pages/settings/GenerateSQL";
import Customers from "@/pages/dod/DodCustomers.vue";
import Employees from "@/pages/dod/DodEmployees.vue";
import DodEmployeesList from "../pages/dod/DodEmployeesList.vue";
import DodReportsList from "../pages/dod/DodReportsList.vue";
import DodSettlementsList from "../pages/dod/DodSettlementsList.vue";
import DodTaskList from "../pages/dod/DodTaskList.vue";
import DodCustomersList from "../pages/dod/DodCustomersList.vue";
import DodSmsList from "../pages/dod/DodSmsList.vue";
import DodDashboard from "../pages/dod/DodDashboard";
import DodAddCustomerAndEmployee from "../pages/dod/DodAddCustomerAndEmployee";
import DodEmployeeDetails from "../pages/dod/DodEmployeeDetails";
import DodCustomerDetails from "../pages/dod/DodCustomerDetails";
import DodPanelSettings from "../pages/dod/DodPanelSettings.vue";
import DodOrdersList from "../pages/dod/DodOrdersList.vue";
import RecurringOrdersReport from "../pages/RecurringOrdersReport.vue";
import CustomerObiady from "../pages/CustomerObiady.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/waitingusers",
    name: "waitingusers",
    component: WaintingUsers,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/triedToLogIn",
    name: "usersWhoTriedToLogIn",
    component: UsersWhoTriedToLogIn,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/unverified-photos",
    name: "unverifiedPhotos",
    component: UnverifiedPhotos,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1", "ADMIN2"],
    },
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
    },
  },
  {
    path: "/obiady",
    name: "RecurringOrdersReport",
    component: RecurringOrdersReport,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/users/id/:id",
    name: "user-details",
    component: UserDetails,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/users/mail",
    name: "mail",
    component: Mail,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/users/search",
    name: "search",
    component: SearchUser,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/chat",
    name: "chat",
    component: Rooms,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3", "ADMIN3"],
    },
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: Tasks,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/user-process",
    name: "UserProcess",
    component: UserProcessPaymentView,
    props: true,
    // beforeEnter: async () => {
    //   await store.dispatch("fetchProcesSettings");
    // },
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/notes/:id",
    name: "Notes",
    component: Notes,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/sms",
    name: "SmsList",
    component: SmsList,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/sms/:id",
    name: "SmsListUser",
    component: SmsListUser,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/promotions/:id",
    name: "UserPromotions",
    component: UserPromotions,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/chat/:id",
    name: "messages",
    component: Messages,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
    },

    children: [
      {
        path: "users-with-service",
        component: UsersWithServiceInArea,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
      },
      {
        path: "promotions",
        component: Promotions,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
      },
      {
        path: "user-commisions",
        name: "UserCommisions",
        component: UserCommisions,
        props: true,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
        },
      },

      {
        path: "reports",
        component: Reports,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "commission",
        component: Commission,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },

      {
        path: "create-service",
        component: CreateService,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "create-sub-category",
        component: CreateSubCategory,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "long-distance-services",
        component: LongDistanceServices,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "services",
        component: ServicesList,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "push-notifications",
        component: PushNotifications,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "notifications-list",
        component: NotificationsList,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "services-order",
        component: ServicesOrder,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "delete-requests",
        component: DeleteRequests,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "send-message",
        component: SendMessage,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        name: "SendMessage",
      },
      {
        path: "parameters",
        component: Parameters,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "send-email",
        component: SendEmail,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "servicesCategories",
        component: ServicesCategories,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "add-admin",
        component: AddAdmin,
      },
      {
        path: "modals",
        component: ModalsManagement,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "news",
        component: News,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "accounting-notes-descriptions",
        component: AccountingNotesDescriptions,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
      {
        path: "generate-sql",
        component: GenerateSQL,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
      },
    ],
  },
  {
    path: "/payments-list",
    name: "PaymentsList",
    component: PaymentsList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/payments-list/:phone",
    name: "PaymentsList",
    component: PaymentsList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/payouts-list",
    name: "Payouts",
    component: Payouts,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1", "ADMIN2"],
    },
  },
  {
    path: "/history",
    name: "services-history",
    component: ServicesHistory,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
    },
  },
  {
    path: "/logs",
    name: "logs",
    component: Logs,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN1"],
    },
  },
  {
    path: "/employee/:id/user-services",
    name: "UserServices",
    component: UserServices,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/employee/:id/orders",
    name: "EmployeeOrders",
    component: EmployeeOrders,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/customer/:id/orders",
    name: "SeniorOrders",
    component: SeniorOrders,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/customer/:id/orders-crs",
    name: "SeniorOrdersCrs",
    component: SeniorOrdersCrs,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/customer/:id/subscriptions",
    name: "Subscriptions",
    component: Subscriptions,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    // Zakładka "Obiady" na karcie użytkownika - dedykowana strona renderująca raport
    // obiadów w trybie embedded: zawężony do jednej osoby i bez globalnych narzędzi.
    path: "/customer/:id/obiady",
    name: "CustomerRecurringOrders",
    component: CustomerObiady,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/senior/id/:id",
    name: "SeniorProfile",
    component: SeniorProfile,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/employee/id/:id",
    name: "EmployeeProfile",
    component: EmployeeProfile,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
    },
  },
  {
    path: "/customers",
    name: "Customers",
    component: Customers,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/customer-details/:id",
    name: "DodCustomerDetails",
    component: DodCustomerDetails,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/employees",
    name: "Employees",
    component: Employees,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/employee-details/:id",
    name: "DodEmployeeDetails",
    component: DodEmployeeDetails,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-employees-list",
    name: "DodEmployeesList",
    component: DodEmployeesList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-reports-list",
    name: "DodReportsList",
    component: DodReportsList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-settlements-list",
    name: "DodSettlementsList",
    component: DodSettlementsList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-tasks-list",
    name: "DodTasksList",
    component: DodTaskList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-orders-list",
    name: "DodOrdersList",
    component: DodOrdersList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },

  {
    path: "/dod-customers-list",
    name: "DodCustomersList",
    component: DodCustomersList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-sms-list",
    name: "DodSmsList",
    component: DodSmsList,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-dashboard",
    name: "DodDashboard",
    component: DodDashboard,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-add-customer-and-employee",
    name: "AddCustomerAndEmployee",
    component: DodAddCustomerAndEmployee,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/dod-panel-settings",
    name: "DodPanelSettings",
    component: DodPanelSettings,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "ADMIN2", "ADMIN1", "ADMIN3"],
      isDodRoute: true,
    },
  },
  {
    path: "/noAccess",
    name: "NoAccess",
    component: NoAccess,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "*",
    component: ErrorPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/admin",
  routes,
});

router.beforeEach((to, from, next) => {
  if (from && from.fullPath !== "/") {
    const lastRouteToSave = {
      name: from.name,
      params: from.params,
      query: { ...from.query },
    };
    window.sessionStorage.setItem(
      "dodLastRoute",
      JSON.stringify(lastRouteToSave)
    );
  }
  const token = window.localStorage.getItem("SAtoken");
  const refreshToken = window.localStorage.getItem("refreshToken");
  const role = Cookies.get("role");
  let tokenToSend;
  const expTime = window.localStorage.getItem("expTime");
  const expTimeRefresh = window.localStorage.getItem("expTimeRefresh");
  if (Date.now() <= expTime * 1000) {
    tokenToSend = token;
  } else {
    tokenToSend = refreshToken;
  }
  axios.defaults.headers.common["Authorization"] = `Bearer ${tokenToSend}`;
  const loggedAdmin = JSON.parse(window.localStorage.getItem("loggedAdmin"));
  const hasUserAccessForDodRoutes =
    loggedAdmin?.hasDodAccess || loggedAdmin?.hasPodAccess;
  if (to.meta?.isDodRoute && !hasUserAccessForDodRoutes) {
    store.dispatch("setDODView", false);
    next("/users");
  } else {
    if (
      to.path !== "/noAccess" &&
      to.meta.roles &&
      role &&
      !to.meta.roles.includes(role)
    ) {
      next("/noAccess");
    } else {
      if (to.meta.requiresAuth === true) {
        try {
          if (expTime < new Date().getTime() / 1000) {
            if (expTimeRefresh > new Date().getTime() / 1000) {
              axios
                .get(`/api/auth/admin/refreshTokens`)
                .then((response) => {
                  window.localStorage.setItem("SAtoken", response.data.token);
                  window.localStorage.setItem(
                    "refreshToken",
                    response.data.refreshToken
                  );
                  const expirationTime = jwt_decode(response.data.token).exp;
                  const expirationTimeRefresh = jwt_decode(
                    response.data.refreshToken
                  ).exp;
                  window.localStorage.setItem("expTime", expirationTime);
                  window.localStorage.setItem(
                    "expTimeRefresh",
                    expirationTimeRefresh
                  );
                  store.dispatch("setExpirationTime");
                })
                .catch((err) => {
                  console.log(err);
                });
              next();
            } else {
              store.dispatch("logout");
              Cookies.set("role", null);
            }
          } else {
            next();
          }
        } catch (err) {
          Cookies.set("role", null);
          store.dispatch("logout");
        }
      } else {
        next();
      }
    }
  }
});

export default router;
